<app-filter-button></app-filter-button>

<div class="total-sales" *ngIf="currentUser.adminNSuperNSales" (click)="openTransactionsWindow()">
  {{deliveredNSold?.amount | number: '1.2-2'}}$ from {{deliveredNSold?.count}} proposals
</div>

<full-calendar #fc [options]="options"></full-calendar>

<p-overlayPanel #eventHintOP styleClass="overlay-panel event-panel">
  <ng-container *ngIf="activityInHint">
    <app-event-tip [activityInHint]="activityInHint"></app-event-tip>
  </ng-container>
</p-overlayPanel>

<p-overlayPanel #holidayOp styleClass="overlay-panel holiday-panel">
  {{holidayStr}}
</p-overlayPanel>

<div class="loading-screen" *ngIf="loadingEvents">
  <lib-progress-spinner></lib-progress-spinner>
</div>


<app-widget-bar *ngIf="isMobile"></app-widget-bar>

<p-confirmDialog appendTo="body" icon="pi pi-exclamation-triangle" styleClass="schedule-panel">
</p-confirmDialog>
